var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tac-admin-payment-reconciliation-batch"}},[_c('summary-section'),_c('transactions-section')],1)}
var staticRenderFns = []

export { render, staticRenderFns }